export default ['False Alarm', 'Training', 'Test', 'Real'].sort()
